module.exports = __webpack_public_path__ + "static/media/btn_delete_patient_done.12887a43.svg";